import { LanguagesStyleModel } from '@/models/header/v2/LanguagesModel'

export function formatLanguagesStyle(data) {
  const h = new LanguagesStyleModel()
  h.fromData(data)

  return h
}
